import { render } from "./ClientDetails.vue?vue&type=template&id=3ccfb7cb&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"

import "./ClientDetails.vue?vue&type=style&index=0&id=3ccfb7cb&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccfb7cb"]])

export default __exports__